module.exports = __webpack_public_path__ + "img/25200.bc9b575d.jpg";